import React, { JSX } from 'react';

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { BookedItemComponentProps } from '../../../Models/ItemRegistry';
import fallback from '../../../_Translations/generated/iso-items-base.en.t.json';
import Keys from '../../../_Translations/generated/iso-items-base.en.t.json.keys';
import useTranslation from '../../Hooks/useTranslation';
import getIconForItemTye from './getItemForItemType';
import SummaryItem from '../../Components/Cart/SummaryItem/SummaryItem';
import Dates from '../Dates';
import { ApiItem, ApiItemType } from '@ibe/api';

const Checkout = (props: BookedItemComponentProps): JSX.Element => {
  const { item, isOpen, onDelete, children, booking, customPriceModifier } = props;

  const { t } = useTranslation('iso-items-base', fallback, Keys);

  const icon = getIconForItemTye(item.itemType);

  const getServiceName = (): string | undefined => {
    if (ApiItemType.PACKAGE === item.itemType || ApiItemType.FLIGHT === item.itemType) {
      return undefined;
    }
    const rate = booking.items.find(it => item?.idParent === it.id) as ApiItem;
    const unit = booking.items.find(it => rate?.idParent === it.id) as ApiItem;
    let service = booking.items.find(it => unit?.idParent === it.id);

    if (!service) {
      // transfer has only two levels
      // therefore unit is already service
      service = unit;
    }
    return service?.name;
  };
  const customPrice = customPriceModifier && customPriceModifier(item);
  return (
    <>
      <div>
        <SummaryItem
          title={getServiceName() || item.name}
          price={customPrice || item.price}
          subtitle={item.itemType}
          icon={<Icon icon={icon} />}
          isOpen={isOpen}
          dates={<Dates item={item} />}
          onDelete={onDelete}
          booking={booking}
          item={item}
        >
          <div className="iso__nav__tabs-container">
            <Nav tabs>
              <NavItem>
                <NavLink className="active">{t(Keys.traveler)}</NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab="traveler">
              <TabPane tabId="traveler">{children}</TabPane>
            </TabContent>
          </div>
        </SummaryItem>
      </div>
    </>
  );
};
export default Checkout;
